import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var CloudOff = createReactComponent("CloudOff", ["svg", defaultAttributes, [["path", {
  d: "M22.61 16.95A5 5 0 0018 10h-1.26a8 8 0 00-7.05-6M5 5a8 8 0 004 15h9a5 5 0 001.7-.3",
  key: "1k46wa"
}], ["line", {
  x1: "1",
  y1: "1",
  x2: "23",
  y2: "23",
  key: "czowfk"
}]]]);
export default CloudOff;